import React, { CSSProperties } from 'react';
import styled from 'styled-components';

export interface Item {
  text: string;
  onSelect: () => void;
}

export interface Props {
  items: Item[];
  style: CSSProperties;
}

const ArrowCover = styled.div`
  background: #fff;
  border-radius: .25rem;
  bottom: 0;
  left: 0;
  position:absolute;
  right: 0;
  top: 0;
`;

const Ul = styled.ul`
  background: #fff;
  border-radius: .25rem;
  box-shadow: 0 0 .25rem #aaa;
  box-sizing: border-box;
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
  z-index: 1;

  &:before {
    content: '';
    position: absolute;
    width: 1rem;
    height: 1rem;
    top: .5rem;
    left: .1rem;
    box-sizing: border-box;
    background: #fff;    
    border: .25rem solid #fff;
    border-color: transparent transparent #fff #fff;  
    transform-origin: 0 0;
    transform: rotate(45deg);
    box-shadow: 0 0 .25rem 0 #aaa;    
  }
`;

const Li = styled.li`
  &:active {
    font-weight: bold;
  }
  &:hover {
    background: #f6f6f6;
    cursor: pointer;
  }

  color: #444;
  display: block;
  padding: .5rem .75rem;
  position: relative;
  white-space: nowrap;
`;

export const ContextMenu = (props: Props) => {
  const { items, style } = props;
  return (
    <Ul style={style}>
      <ArrowCover />
      {items.map((item) => <Li key={item.text} onClick={() => item.onSelect()}>{item.text}</Li>)}
    </Ul>
  );
};
